<div id="vue-amazon-pay-button" ref="amazonPayContainer" :class="{'d-none': isButtonHidden}"></div>
